export const CONSENT_VERSION = "2026-09-25";
export const CONSENT_COOKIE = "iva_cookie_choice";
export const REMEMBER_COOKIE = "iva_remembered_email";
export const INVITE_COOKIE = "iva_invite_code";
export const CONSENT_DAYS = 180;
export const REMEMBER_DAYS = 90;
export const REJECTED_CHOICE = `${CONSENT_VERSION}:rejected`;

export interface CookieChoices { preferences: boolean; affiliates: boolean }
export interface ConsentReceipt extends CookieChoices {
  id: string;
  version: string;
  created_at: string;
  expires_at: string;
  withdrawn_at?: string | null;
}
export const rejectedChoices: CookieChoices = { preferences: false, affiliates: false };
export function parseChoices(value: unknown): CookieChoices | undefined {
  if (!value || typeof value !== "object") return;
  const item = value as Record<string, unknown>;
  if (item.version !== CONSENT_VERSION || typeof item.preferences !== "boolean" || typeof item.affiliates !== "boolean") return;
  return { preferences: item.preferences, affiliates: item.affiliates };
}
